import React from 'react';
import { generalConstants } from '../constants';

class ImageInput extends React.Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    this.refs.fileUploader.click();
  }

  render() {
    const imgStyle = {
      maxWidth: '100%',
      maxHeight: '100%'
    };

    const { 
        input_type, 
        input_name, 
        input_label, 
        input_value, 
        input_placeholder, 
        input_onChange,
        input_invalid_feedback,
        input_helper,
        input_is_required,
        input_parent,
      } = this.props;

    return (
      <div className="form-group">
        <label className="form-control-label">{input_label}</label>
        <input
          type="file"
          ref="fileUploader"
          name={ input_name }
          style={{ display: 'none' }}
          onChange={input_onChange}
          data-parent={ input_parent }
        />
        <div className="d-block clearfix m-b-1">
          <button
            className={'uploader-img' + (input_value ? ' uploader-img-filled' : '')}
            onClick={this.handleClick}
          >
            {input_value ? (
              <img
                src={generalConstants.BASE_URL + input_value.data.data.url}
                style={imgStyle}
                className="img-fluid"
                alt="Image Uploaded"
              />
            ) : (
              <div className="icon">
                <i className="fal fa-arrow-alt-up" />
              </div>
            )}
          </button>
        </div>
        <small className="help-block">{input_helper}</small>
        <div className="invalid-feedback">{ input_invalid_feedback }</div>
      </div>
    );
  }
}

export { ImageInput };



// WEBPACK FOOTER //
// ./src/components/ImageInput.js